import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Portal, Button, Popup } from 'semantic-ui-react'
import { Group, Form, Field, Columns, Submit, InfoGroup, Info } from '~/form'

function DeletePrompt({ onAnswer }) {
  let deleteContent = (
    <div className="prompt">
      <b>Oletko varma?</b>
      <div className="prompt-button">
        <Button size="tiny" as="a" content="Kyllä" onClick={e => e.preventDefault() & onAnswer(true)} color="red" />
      </div>
    </div>
  )

  return (
    <Popup
      trigger={
        <div role="button" className="button-plain">
          Poista
        </div>
      }
      content={deleteContent}
      on="click"
      position="top left"
    />
  )
}

let taskLevels = [
  { value: '1', label: 'Taso 1' },
  { value: '2', label: 'Taso 2' },
  { value: '3', label: 'Taso 3' },
]

export let statusOptions = [
  { value: 'pending', label: 'Odottaa' },
  { value: 'working', label: 'Työn alla' },
  { value: 'completed', label: 'Valmis' },
]

let hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
let minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']
let durationOptions = []

for (let hour of hours) {
  for (let minute of minutes) {
    let value = `${hour}:${minute}`
    durationOptions.push({ value, text: value })
  }
}

export default function TaskForm({
  formUpdate,
  formSubmit,
  formState,
  formLoading,
  types,
  typesLoading,
  title = 'Muokkaa tehtävää',
  hasDelete = false,
}) {
  let { values } = formState
  let project_id = values.get('project_id')
  let task_type_id = values.get('task_type_id')
  let taskType = types.find(t => t.get('id') === task_type_id)
  if (!Map.isMap(taskType)) taskType = Map()

  return (
    <Fragment>
      <Group title={title}>
        {typesLoading ? (
          <div>Ladataan tyyppejä..</div>
        ) : (
          <Field
            type="select"
            name="task_type_id"
            label="Tyyppi"
            options={types
              .map(t => ({ value: t.get('id'), icon: t.getIn(['data', 'icon'], 'check'), text: t.get('name') }))
              .toArray()
              .sort((a, b) => (a.value > b.value ? 1 : -1))}
            onChange={data => {
              let { value: task_type_id } = data
              let taskType = types.find(t => t.get('id') === task_type_id)
              if (taskType)
                formUpdate({
                  name: 'data._task',
                  value: {
                    icon: taskType.getIn(['data', 'icon']),
                    order: parseInt(taskType.getIn(['data', 'order'], 99)),
                    name: taskType.get('name'),
                    id: taskType.get('id'),
                  },
                })

              formUpdate(data)
            }}
            formState={formState}
          />
        )}
        <Field
          size="large"
          type="text"
          name="data.subject"
          placeholder={taskType.get('name', 'Aihe')}
          onChange={formUpdate}
          formState={formState}
        />
        <Columns count="2">
          <Field
            label="Status"
            type="radios"
            inline
            name="status"
            options={statusOptions}
            onChange={formUpdate}
            formState={formState}
          />
          <Field
            label="Taso"
            type="radios"
            inline
            name="data.level"
            options={taskLevels}
            onChange={formUpdate}
            formState={formState}
          />
        </Columns>
        <Columns count="2">
          <Field label="Määräaika" type="datetime" name="deadline" onChange={formUpdate} formState={formState} />
          <Columns count="2">
            <Field
              label="Kesto"
              type="select"
              name="data.duration"
              options={durationOptions}
              onChange={formUpdate}
              formState={formState}
            />
            <Field
              label="Kalenterisynkkaus"
              inputLabel="Päivitä kalenteria"
              type="checkbox"
              name="data.enableCalendarSync"
              onChange={formUpdate}
              formState={formState}
            />
          </Columns>
        </Columns>
        {task_type_id === 'INTERVIEW' ? (
          <Field label="Osoite" type="map" name="data.coordinates" onChange={formUpdate} formState={formState} />
        ) : null}
        <Field label="Muistiinpanot" type="wysiwyg" name="data.notes" onChange={formUpdate} formState={formState} />
        <Field
          label="Vastuuhenkilö"
          type="reference"
          referenceConfig={{ id: 'taskUser', options: { source: 'user' } }}
          name="user_id"
          onChange={formUpdate}
          formState={formState}
        />
      </Group>
      <Group>
        <Field type="links" name="links" onChange={formUpdate} formState={formState} />
      </Group>
      {hasDelete ? (
        <Group>
          <DeletePrompt onAnswer={answer => (answer ? formSubmit({ isDelete: true }) : null)} />
        </Group>
      ) : null}
    </Fragment>
  )
}

export let TaskFormValidations = {
  task_type_id: ['required'],
}
